<div [formGroup]="parentGroup" class="border-area">
    <div formArrayName="subFieldConf">
        <h4 class="my-0 mb-2" style="font-weight:normal;">Dropdown-Konfiguration</h4>

        @if (getDetailGroup(parentGroup); as detailGroup) {
            <div class="border-area" [formGroup]="detailGroup">
                <h4>Dropdown Detail</h4>

                <div class="option-row">

                    <mat-form-field>
                        <mat-label>API URL</mat-label>
                        <input matInput formControlName="apiGetURL" />
                    </mat-form-field>

                </div>

                <div class="option-row">

                    <mat-form-field>
                        <mat-label>Key</mat-label>
                        <input matInput formControlName="key" />
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label" />
                    </mat-form-field>

                </div>

                <div class="option-row">

                    <mat-form-field>
                        <mat-label>Reda Label</mat-label>
                        <input matInput formControlName="redaLabel" />
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Sub Label</mat-label>
                        <input matInput formControlName="subLabel" />
                    </mat-form-field>

                </div>

                <!-- HEADERS ARRAY -->
                <div formArrayName="headers">
                    <h5>Headers</h5>

                    @for (hdr of getHeadersArray(parentGroup).controls; track hdr; let i = $index) {
                        @if (isFormGroup(hdr)) {
                            <div [formGroupName]="i">

                                <div class="option-row">

                                    <mat-form-field>
                                        <mat-label>Name</mat-label>
                                        <input matInput formControlName="name" />
                                    </mat-form-field>

                                    <button mat-icon-button color="warn"
                                            (click)="removeHeader(parentGroup, i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>

                                </div>

                                <!-- VALUES -->
                                <div formArrayName="values" class="border-area mb-2">
                                    @for (val of getHeaderValuesArray(hdr).controls; track val; let j = $index) {
                                        <div class="option-row">
                                            <mat-form-field>
                                                <mat-label>Value</mat-label>
                                                <input matInput [formControlName]="j" />
                                            </mat-form-field>

                                            <button mat-icon-button color="warn"
                                                    (click)="removeHeaderValue(hdr, j)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    }

                                    <button mat-stroked-button (click)="addHeaderValue(hdr)">
                                        Value hinzufügen
                                    </button>
                                </div>
                            </div>
                        }
                    }

                    <button mat-raised-button (click)="addHeader(parentGroup)">
                        Header hinzufügen
                    </button>
                </div>
            </div>
        }



        @for (opt of options.controls; track opt) {
            @if (isFormGroup(opt)) {
                <div [formGroup]="opt" class="border-area">

                    <!-- Option row -->
                    <div class="option-row">
                        <mat-form-field>
                            <mat-label>Label</mat-label>
                            <input matInput formControlName="label" required />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" required />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Typ</mat-label>
                            <mat-select formControlName="datatype">
                                @for (dt of datatypeOptions; track dt) {
                                    <mat-option [value]="dt">{{ dt }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <button mat-icon-button color="warn" (click)="removeSubField(options, $index)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>


                    <!-- Nested subFieldConf -->
                    <div class="sub-config border-area" formArrayName="subFieldConf">
                        @for (sub of getSubFieldConf(opt).controls; track sub) {
                            @if (isFormGroup(sub)) {
                                <div [formGroupName]="$index">
                                    <div class="option-row">

                                        <mat-form-field>
                                            <mat-label>Unterfeld Label</mat-label>
                                            <input matInput formControlName="label" required />
                                        </mat-form-field>

                                        <mat-form-field>
                                            <mat-label>Unterfeld Name</mat-label>
                                            <input matInput formControlName="name" required />
                                        </mat-form-field>

                                        <mat-form-field>
                                            <mat-label>Typ</mat-label>
                                            <mat-select formControlName="datatype">
                                                @for (dt of datatypeOptions; track dt) {
                                                    <mat-option [value]="dt">{{ dt }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <button mat-icon-button color="warn" (click)="removeSubField(getSubFieldConf(opt), $index)">
                                            <mat-icon>delete</mat-icon>
                                        </button>

                                    </div>
                                </div>
                            }
                        }
                        <button mat-stroked-button (click)="addSubField(getFormGroup(opt)!)">
                            Unterfeld hinzufügen
                        </button>
                    </div>

                </div>
            }
        }

    </div>

    <button mat-raised-button color="primary" (click)="addSubField(parentGroup)">
        Option hinzufügen
    </button>
</div>
